import React from 'react';

import {Box, Card, Typography, Stack} from 'views/components';
import {Translate} from 'views/module';
import {Check} from 'views/icons';

const EventFeedbackThankYou = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '100vh',
        px: 2,
      }}
    >
      <Card
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: 900,
          p: 4,
          borderRadius: '12px',
          textAlign: 'center',
          bgcolor: 'color.white',
        }}
      >
        <Stack alignItems="center" spacing={2}>
          <Box
            sx={{
              bgcolor: '#077757',
              width: {
                xs: 48,
                sm: 56,
                md: 64,
                lg: 72,
                xl: 80,
                xxl: 88,
              },
              height: {
                xs: 48,
                sm: 56,
                md: 64,
                lg: 72,
                xl: 80,
                xxl: 88,
              },
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 1,
            }}
          >
            <Check
              sx={{
                fontSize: '2.25rem',
                color: 'color.white',
              }}
            />
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
            }}
          >
            <Translate expression='eventFeedback.ThankYou.Title'/>
          </Typography>
          <Typography
            sx={{
              color: 'grey.700',
              fontSize: '1.1rem',
            }}
          >
            <Translate expression='eventFeedback.ThankYou.Message'/>
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
};

export default React.memo(EventFeedbackThankYou);
